export interface TikTokVideo {
  id: string;
  author: string;
  handle: string;
  caption: string;
  category: 'Tendance' | 'Nouveauté' | 'Actu' | 'Humour' | 'Danse' | 'Lifestyle';
  thumbnail_url: string;
  video_id: string;
  views: number;
  likes: number;
  comments: number;
  location: string;
}

export const tiktokVideos: TikTokVideo[] = [
  {
    id: 'tt-1',
    author: 'Ama Kodjo',
    handle: '@amakodjo',
    caption: 'Le challenge afrobeat qui fait danser tout Lomé 🔥 #danse #afrobeat #togo',
    category: 'Tendance',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Young%20Togolese%20dancer%20performing%20an%20energetic%20afrobeat%20dance%20challenge%20outdoors%20in%20a%20colorful%20urban%20street%20of%20Lome%20with%20vibrant%20motion%20and%20bright%20warm%20sunlight%20vertical%20TikTok%20style%20video%20thumbnail%20rich%20warm%20golden%20tones%20high%20detail&width=720&height=1280&seq=tiktok-1&orientation=portrait',
    video_id: '7494027474813177118',
    views: 892000,
    likes: 124000,
    comments: 8300,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-2',
    author: 'Désiré Amouzou',
    handle: '@desirecomedy',
    caption: 'Quand ta mère découvre ton forfait 😂😂 #sketch #comédie #humour',
    category: 'Humour',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20comedian%20making%20an%20expressive%20funny%20face%20gesture%20in%20front%20of%20a%20colorful%20wall%20humorous%20skit%20moment%20bright%20daylight%20energetic%20personality%20vertical%20TikTok%20style%20video%20thumbnail%20warm%20vibrant%20saturated%20colors%20high%20detail&width=720&height=1280&seq=tiktok-2&orientation=portrait',
    video_id: '7651895899207109906',
    views: 1450000,
    likes: 210000,
    comments: 15600,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-3',
    author: 'Adjoa Mensah',
    handle: '@adjoastyle',
    caption: 'Ma tenue wax sur mesure du jour 💛✨ #mode #wax #style',
    category: 'Lifestyle',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Elegant%20African%20woman%20showing%20off%20a%20vibrant%20wax%20print%20outfit%20with%20gold%20accessories%20in%20a%20bright%20modern%20setting%20confident%20pose%20warm%20studio%20lighting%20vertical%20TikTok%20fashion%20video%20thumbnail%20rich%20warm%20terracotta%20tones%20high%20detail&width=720&height=1280&seq=tiktok-3&orientation=portrait',
    video_id: '7514315106801421590',
    views: 421000,
    likes: 68000,
    comments: 4100,
    location: 'Cotonou, Bénin',
  },
  {
    id: 'tt-4',
    author: 'Chef Ama',
    handle: '@chefama',
    caption: 'La vraie recette du fufu maison 🍲 #recette #gastronomie #cuisine',
    category: 'Nouveauté',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20chef%20smiling%20while%20cooking%20a%20traditional%20dish%20in%20a%20rustic%20kitchen%20steam%20rising%20fresh%20colorful%20ingredients%20on%20the%20table%20warm%20ambient%20light%20vertical%20TikTok%20cooking%20video%20thumbnail%20rich%20warm%20earthy%20tones%20high%20detail&width=720&height=1280&seq=tiktok-4&orientation=portrait',
    video_id: '7654708635926367509',
    views: 318000,
    likes: 47000,
    comments: 2900,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-5',
    author: 'Atelier Kossi',
    handle: '@kossihandmade',
    caption: 'Tisser un panier en raphia pas à pas 🧺 #artisanat #tutoriel',
    category: 'Tendance',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20weaving%20a%20traditional%20raffia%20basket%20artisan%20craftsmanship%20bright%20natural%20workshop%20light%20warm%20earthy%20tones%20vertical%20TikTok%20tutorial%20video%20thumbnail%20rich%20warm%20colors%20high%20detail&width=720&height=1280&seq=tiktok-5&orientation=portrait',
    video_id: '7629258824263912722',
    views: 156000,
    likes: 23000,
    comments: 1800,
    location: 'Kpalimé, Togo',
  },
  {
    id: 'tt-6',
    author: 'Koffi TV',
    handle: '@koffitv',
    caption: 'Ce qui se passe au grand marché de Lomé aujourd&apos;hui 📍 #actu #togo',
    category: 'Actu',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Young%20African%20content%20creator%20recording%20a%20street%20interview%20in%20a%20lively%20market%20of%20Lome%20Togo%20colorful%20stalls%20people%20in%20the%20background%20bright%20daylight%20vertical%20TikTok%20news%20video%20thumbnail%20warm%20vibrant%20tones%20high%20detail&width=720&height=1280&seq=tiktok-6&orientation=portrait',
    video_id: '7639691350660762887',
    views: 267000,
    likes: 19000,
    comments: 3200,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-7',
    author: 'Afro Crew',
    handle: '@afrocrew',
    caption: 'On a reproduit la choré virale ensemble 💃🕺 #danse #challenge',
    category: 'Danse',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Group%20of%20young%20African%20friends%20doing%20a%20synchronized%20dance%20challenge%20together%20outdoors%20at%20sunset%20joyful%20energy%20golden%20hour%20light%20vertical%20TikTok%20dance%20video%20thumbnail%20warm%20golden%20tones%20high%20detail&width=720&height=1280&seq=tiktok-7&orientation=portrait',
    video_id: '7524619553511427333',
    views: 780000,
    likes: 96000,
    comments: 5400,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-8',
    author: 'Les Frères',
    handle: '@lesfreres',
    caption: 'Le sketch qui résume la réunion de famille 😂 #comédie #humour',
    category: 'Humour',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20comedian%20duo%20acting%20a%20funny%20comedy%20sketch%20on%20a%20simple%20colorful%20stage%20expressive%20exaggerated%20gestures%20bright%20stage%20lighting%20vertical%20TikTok%20comedy%20video%20thumbnail%20warm%20vibrant%20colors%20high%20detail&width=720&height=1280&seq=tiktok-8&orientation=portrait',
    video_id: '7556582065441934614',
    views: 1120000,
    likes: 158000,
    comments: 9800,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-9',
    author: 'Jeandatol',
    handle: '@jeandatol_',
    caption: 'Le sketch qui tourne dans tout le 228 😂 #togotiktok228 #humour',
    category: 'Humour',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20comedian%20making%20an%20expressive%20humorous%20face%20gesture%20in%20a%20colorful%20Togolese%20street%20setting%20confident%20personality%20bright%20daylight%20vertical%20TikTok%20comedy%20video%20thumbnail%20warm%20vibrant%20saturated%20colors%20high%20detail&width=720&height=1280&seq=tiktok-9&orientation=portrait',
    video_id: '7515904330403351864',
    views: 2400000,
    likes: 380000,
    comments: 21000,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-10',
    author: 'Bhadie Kelly',
    handle: '@bhadie.kellyy',
    caption: 'La choré qui a fait le tour du monde 💃✨ #danse #viral',
    category: 'Danse',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Young%20African%20woman%20dancing%20an%20energetic%20viral%20choreography%20in%20a%20bright%20stylish%20room%20confident%20joyful%20expression%20warm%20golden%20lighting%20vertical%20TikTok%20dance%20video%20thumbnail%20rich%20warm%20tones%20high%20detail&width=720&height=1280&seq=tiktok-10&orientation=portrait',
    video_id: '7671630439282380062',
    views: 8700000,
    likes: 1100000,
    comments: 45000,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-11',
    author: 'Général Montana',
    handle: '@le_general_montana',
    caption: 'Afro Fusion House, la vibe de ce soir 🎧🔥 #afrohouse #musique',
    category: 'Tendance',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20music%20artist%20with%20headphones%20performing%20an%20afro%20fusion%20house%20beat%20in%20a%20neon%20lit%20studio%20dramatic%20warm%20lighting%20confident%20pose%20vertical%20TikTok%20music%20video%20thumbnail%20rich%20golden%20and%20amber%20tones%20high%20detail&width=720&height=1280&seq=tiktok-11&orientation=portrait',
    video_id: '7670868310828879136',
    views: 1200000,
    likes: 160000,
    comments: 9000,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-12',
    author: 'CDK GROUP',
    handle: '@cdk_group',
    caption: 'Le concert de Himra à Lomé, c\u2019est le feu 🔥 #concert #togo',
    category: 'Actu',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Massive%20African%20concert%20crowd%20with%20hands%20raised%20under%20dramatic%20stage%20lights%20warm%20golden%20haze%20energetic%20festival%20atmosphere%20vertical%20TikTok%20concert%20video%20thumbnail%20rich%20warm%20tones%20high%20detail&width=720&height=1280&seq=tiktok-12&orientation=portrait',
    video_id: '7622851427378990358',
    views: 980000,
    likes: 88000,
    comments: 12000,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-13',
    author: 'Emmanuel Adebayor',
    handle: '@e_adebayor',
    caption: 'La belle vie, entre famille et passion ⚽✨ #sea #football',
    category: 'Lifestyle',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20football%20legend%20smiling%20and%20enjoying%20life%20outdoors%20with%20a%20luxury%20villa%20in%20the%20background%20golden%20hour%20sunlight%20relaxed%20joyful%20mood%20vertical%20TikTok%20lifestyle%20video%20thumbnail%20warm%20golden%20tones%20high%20detail&width=720&height=1280&seq=tiktok-13&orientation=portrait',
    video_id: '7652285481656388882',
    views: 5400000,
    likes: 620000,
    comments: 33000,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-14',
    author: 'Neil',
    handle: '@togo_sur_mesure',
    caption: 'À la découverte des merveilles du Togo 🇹🇬 #tourisme #voyage',
    category: 'Lifestyle',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Young%20African%20travel%20content%20creator%20standing%20on%20a%20scenic%20Togolese%20landscape%20with%20rolling%20hills%20and%20palm%20trees%20golden%20hour%20light%20holding%20a%20camera%20adventurous%20mood%20vertical%20TikTok%20travel%20video%20thumbnail%20warm%20earthy%20tones%20high%20detail&width=720&height=1280&seq=tiktok-14&orientation=portrait',
    video_id: '7672446320149351712',
    views: 640000,
    likes: 74000,
    comments: 5000,
    location: 'Kpalimé, Togo',
  },
  {
    id: 'tt-15',
    author: 'TV7',
    handle: '@donnetv7',
    caption: 'Le showbiz et l\u2019actu du Togo en direct 📺🔥 #tv7 #showbiz #togo',
    category: 'Actu',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Young%20African%20journalist%20recording%20a%20live%20showbiz%20news%20report%20in%20a%20modern%20Togolese%20television%20studio%20with%20professional%20microphone%20and%20camera%20equipment%20warm%20studio%20lighting%20bright%20colorful%20set%20vertical%20TikTok%20news%20video%20thumbnail%20rich%20warm%20tones%20high%20detail&width=720&height=1280&seq=tiktok-15&orientation=portrait',
    video_id: '7533292693905001734',
    views: 1500000,
    likes: 190000,
    comments: 24000,
    location: 'Lomé, Togo',
  },
  {
    id: 'tt-16',
    author: 'Hodako TV',
    handle: '@hodakotv2288',
    caption: 'Showbiz togolais : les coulisses et les buzz du 228 🎬 #hodakotv #showbiz',
    category: 'Actu',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20showbiz%20host%20presenting%20an%20entertainment%20news%20segment%20in%20a%20colorful%20studio%20with%20neon%20accents%20expressive%20gesture%20bright%20energetic%20lighting%20vertical%20TikTok%20showbiz%20video%20thumbnail%20warm%20vibrant%20tones%20high%20detail&width=720&height=1280&seq=tiktok-16&orientation=portrait',
    video_id: '7598494032985066782',
    views: 980000,
    likes: 120000,
    comments: 15000,
    location: 'Lomé, Togo',
  },
];